import { render } from "./OfferingPress.vue?vue&type=template&id=425d2088"
import script from "./OfferingPress.vue?vue&type=script&lang=js"
export * from "./OfferingPress.vue?vue&type=script&lang=js"
script.render = render

export default script